import clsx from 'clsx';
import React, { type ReactNode, useEffect, useState } from 'react';

import { Icon } from './Icon';
import { Button } from 'antd';

interface RightPanelProps {
  isOpen: boolean;
  onClose: () => void;
  children?: ReactNode;
  hasCloseButton?: boolean;
}

const RightPanel: React.FC<RightPanelProps> = ({
  isOpen,
  onClose,
  children,
  hasCloseButton = true,
}) => {
  /**
   * Closes the handle and performs necessary actions based on the dirty state.
   */
  const handleClose = async () => {
    onClose();
  };

  const animationDuration = 100;

  const [isContentVisible, setIsContentVisible] = useState(false);

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;

    if (isOpen) {
      timeout = setTimeout(() => {
        setIsContentVisible(true);
      }, animationDuration + 100);
    } else {
      setIsContentVisible(false); // nasconde subito
    }

    return () => clearTimeout(timeout);
  }, [isOpen]);

  return (
    <aside
      className={clsx(
        `border-medium-gray fixed bottom-0 right-0 top-14 z-30 flex flex-shrink-0 flex-col border bg-white transition-all duration-${animationDuration} overflow-hidden ease-in-out`,
        isOpen ? 'w-full max-w-[350px] opacity-100' : 'pointer-events-none w-0 max-w-0 opacity-0',
      )}
    >
      {hasCloseButton && (
        <Button
          aria-label="Toggle panel"
          type="text"
          onClick={handleClose}
          className="absolute right-4 top-4 z-40 flex shrink-0 items-center"
        >
          <Icon
            name="XIcon"
            className={clsx(
              'm-auto transition-all duration-200 ease-in-out',
              isOpen ? 'rotate-180' : 'rotate-0',
            )}
          />
        </Button>
      )}
      {isContentVisible && (
        <div className={clsx('relative h-full px-2', hasCloseButton && 'pt-8')}>{children}</div>
      )}
    </aside>
  );
};

export default RightPanel;
